import {CommonContainerConst} from '@multipass-common';
import {ServiceClientContainerConsts} from '@multipass-service-ioc';
import {Router} from '@multipass-system';
import {Module, ModuleBuilder} from 'esp-js-ui';

import {AccountService, DefaultAccountService, DefaultLegalDocumentsService, DefaultSessionService, DefaultSignupService, LegalDocumentsService, SessionService, SignupService} from './dal';
import {ShellContainerConsts} from './ioc';
import {LocaleService, registerSessionStore} from './logic';

export const createSessionModule = (): Module =>
    ModuleBuilder.create('session')
        .withContainerConfiguration(container => {
            container
                .register(ShellContainerConsts.session_service, DefaultSessionService)
                .inject(ServiceClientContainerConsts.multipassUserService_userService)
                .singleton();
            container
                .register(ShellContainerConsts.signup_service, DefaultSignupService)
                .inject(ServiceClientContainerConsts.multipassUserService_userService)
                .singleton();
            container
                .register(ShellContainerConsts.legal_documents_service, DefaultLegalDocumentsService)
                .inject(ServiceClientContainerConsts.multipassUserService_userService)
                .singleton();
            container
                .register(ShellContainerConsts.account_service, DefaultAccountService)
                .inject(ServiceClientContainerConsts.multipassUserService_userService)
                .singleton();
        })
        .withInitialisation(async app => {
            const sessionService = app.container.resolve<SessionService>(ShellContainerConsts.session_service);
            const signupService = app.container.resolve<SignupService>(ShellContainerConsts.signup_service);
            const legalDocumentsService = app.container.resolve<LegalDocumentsService>(ShellContainerConsts.legal_documents_service);
            const accountService = app.container.resolve<AccountService>(ShellContainerConsts.account_service);
            const router = app.container.resolve<Router>(CommonContainerConst.router);
            const localeService = app.container.resolve<LocaleService>(ShellContainerConsts.locale_service);
            registerSessionStore(app.eventBus, sessionService, signupService, legalDocumentsService, router, accountService, localeService);
        })
        .build();
